<template>
  <Navbar v-if="$route.name === 'consultants'"/>
  <Breadcrumb v-if="$route.name === 'consultants'" />
  <div v-show="consultant_id == 0 && sendingbulkemail == 0" class="px-3">
      <div class="row mt-3 mb-3">
        <div class="col-8">
          <div class="d-flex flex-nowrap" style="gap: 0.5rem;">
            <button
              @click.prevent.stop="addconsultant"
              class="btn btn-primary gdq_faded gdq-font-size-80"
              style="width: 8.33%;"
              ><span class="icon-plus mr-1"></span>Add</button
            >
            <select
              placeholder="Actions"
              v-model="bulkaction"
              class="gdq-font-size-80"
              style="width: 8.33%;"
              @change="dobulkaction"
            >
              <option value="0" class="text-muted">Actions</option>
              <option v-show="selectcount != 0" value="1">
                Add label to selected
              </option>
              <option v-show="selectcount != 0" value="2">
                Export selected to Excel
              </option>
              <option v-show="consultants.length > 0" value="4">
                Export ALL in list to Excel
              </option>
              <option value="3">Import from Excel</option>
              <option v-show="selectcount != 0" value="5">
                Send bulk email to selected
              </option>
              <option v-show="consultants.length > 0" value="6">
                Send bulk email ALL in list
              </option>
            </select>
            <LabelSelect
              @input="consultants_filterget"
              v-model="filterlabel"
              :options="alllabels"
              class="gdq-font-size-80"
              style="width: 16.66%;"
              placeholder="Labels"
            />
            <select
              @change="consultants_filterget"
              v-model="filterusergroup"
              class="form-select gdq-font-size-80"
              style="width: 16.66%;"
            >
              <option value="0">Roles</option>
              <option v-for="group in allusergroups.slice(1)" :key="group.value" :value="group.value">{{ group.text }}</option>
            </select>
            <select
              v-model="newsletter"
              @change="consultants_filterget"
              class="form-select gdq-font-size-75"
              style="width: 8.33%;"
            >
              <option :value="null">Newsletter all</option>
              <option :value="1">Has newsletter</option>
              <option :value="0">No newsletter</option>
            </select>          
            <select
              @change="consultants_filterget"
              v-model="consultantstatus_id"
              class="form-select gdq-font-size-80"
              style="width: 16.66%;"
            >
              <option value="0">Status</option>
              <option v-for="status in consultantstatuses.slice(1)" :key="status.value" :value="status.value">{{ status.text }}</option>
            </select>
            <select
              @change="consultants_filterget"
              v-model="consultantgroup_id"
              class="form-select gdq-font-size-80"
              style="width: 16.66%;"
            >
              <option value="0">Groups</option>
              <option v-for="group in consultantgroups.slice(1)" :key="group.value" :value="group.value">{{ group.text }}</option>
            </select>
            <select
              @change="consultants_filterget"
              v-model="consultantstate"
              class="form-select gdq-font-size-80"
              style="width: 16.66%;"
            >
              <option value="0">Active</option>
              <option value="1">Deleted</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <div class="input-group input-group-sm">
            <input
              v-model="searchId"
              placeholder="Id, Survey ID"
              type="text"
              @input="consultants_filter"
              class="form-control gdq-font-size-80"
              autocomplete="off"
            />
            <button class="btn btn-outline-secondary" type="button" @click="searchId = ''">X</button>
          </div>
        </div>
        <div class="col-2">
          <div class="input-group input-group-sm">
            <input
              v-model="search"
              placeholder="Name/e-mail..."
              type="text"
              @input="consultants_filter"
              class="form-control gdq-font-size-80"
              autocomplete="off"
            />
            <button class="btn btn-outline-secondary" type="button" @click="search = ''">X</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-3 text-start">Number of consultants in the list: {{ rows }}</div>
      </div>

      <div class="row" v-show="bulkaction == 1 || bulkaction == 2 || bulkaction == 4">
        <div
          v-show="bulkaction == 1"
          class="col-2 mt-3 mb-3"
        >
          <div class="input-group input-group-sm">
            <input
              v-model="bulkaddinglabeltext"
              placeholder="Label"
              type="text"
              class="form-control"
              autocomplete="off"
            />
            <button 
              class="btn btn-sm p-0" 
              type="button"
              :class="bulkaddinglabeltext == '' ? 'btn-danger' : 'btn-success'"
              @click="bulkaddinglabeltext == '' ? bulkaddlabel_cancel() : bulkaddlabel_save()"
            >
              <span v-show="bulkaddinglabeltext != ''" class="icon-checkmark" style="color: black"></span>
              <span v-show="bulkaddinglabeltext == ''" class="icon-cross" style="color: black"></span>
            </button>
          </div>
        </div>
        <div v-show="bulkaction == 2 || bulkaction == 4" class="col-3 mt-3 mb-3">
          <div class="input-group input-group-sm">
            <input
              v-model="exportexcelfilename"
              placeholder="Enter Excel file name"
              type="text"
              class="form-control"
              autocomplete="off"
            />
            <button 
              class="btn btn-sm p-0" 
              type="button"
              :class="exportexcelfilename == '' ? 'btn-danger' : 'btn-success'"
              @click="exportexcelfilename == '' ? exportexcel_cancel() : exportexcel_save()"
            >
              <span v-show="exportexcelfilename != ''" class="icon-checkmark" style="color: black"></span>
              <span v-show="exportexcelfilename == ''" class="icon-cross" style="color: black"></span>
            </button>
          </div>
        </div>
      </div>
      
      <div v-if="deleteerror == 1" class="alert alert-danger" role="alert">
        The consultant cannot be deleted, he/she has open surveys
      </div>
      
      <table class="table table-hover consultantsTable">
        <thead>
          <tr>
            <th style="width: 40px;">
              <input type="checkbox" v-model="selected" @change="selectall(selected)" />
            </th>
            <th style="cursor:pointer;" @click="handleSort('id')">
              ID <span v-if="orderby === 'id'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th class="col-2 gdq-w-15" style="cursor:pointer;" @click="handleSort('consultant_name')">
              Name <span v-if="orderby === 'consultant_name'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('email')">
              E-mail <span v-if="orderby === 'email'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('consultantstatus_name')">
              Status <span v-if="orderby === 'consultantstatus_name'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th class="col-1 gdq-w-5" style="cursor:pointer;" @click="handleSort('certificate_number')">
              GDQ# <span v-if="orderby === 'certificate_number'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th class="col-1 gdq-w-10" style="cursor:pointer;" @click="handleSort('certification_date')">
              Cert.date <span v-if="orderby === 'certification_date'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('partner_name')">
              Partner <span v-if="orderby === 'partner_name'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('groupcount')">
              Groups <span v-if="orderby === 'groupcount'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th class="col-5">Labels</th>
            <th class="col-1 gdq-w-10">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in consultants"
            :key="item.id"
            style="cursor: pointer;"
            @click="selectConsultant(item)"
          >
            <td>
              <input type="checkbox" v-model="item.selected" @change="countselected" @click.stop />
            </td>
            <td>{{ item.id }}</td>
            <td :class="anon ? 'g-anon' : ''">{{ item.consultant_name }}</td>
            <td :class="anon ? 'g-anon' : ''">{{ item.email }}</td>
            <td>{{ item.consultantstatus_name }}</td>
            <td>{{ item.certificate_number }}</td>
            <td>{{ item.certification_date }}</td>
            <td>{{ item.partner_name }}</td>
            <td>{{ item.groupcount }}</td>
            <td>
              <span
                v-for="label in (item.labels || [])"
                :key="label.id"
                class="badge me-1"
                style="font-size: 0.875rem;"
                :style="{ backgroundColor: '#' + (label.color || 'ccc'), color: '#000' }"
              >
                {{ label.label }}
                <span
                  class="ms-1"
                  style="cursor:pointer;"
                  @click.stop.prevent="removelabel(item.id, label.id)"
                >
                  <fa-icon name="trash-alt" />
                </span>
              </span>
              <span
                class="ms-1 text-success"
                style="cursor:pointer;"
                @click.stop.prevent="addlabel(item.id)"
              >
                +
              </span>
              <div
                v-if="addinglabel === item.id"
                class="input-group input-group-sm mt-1"
              >
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="addinglabeltext"
                  placeholder="Add label"
                  @keyup.enter.prevent="saveaddlabel"
                  @keyup.escape.prevent="addinglabel = 0"
                  :ref="'l' + item.id"
                />
                <button class="btn btn-outline-secondary btn-sm" @click.prevent="addinglabel = 0">X</button>
              </div>
            </td>
            <td>
              <span
                class="me-2"
                style="cursor: pointer;"
                @click.prevent.stop="switchto(item.id)"
              >
                <fa-icon name="key" />
              </span>
              <span
                v-if="item.deleted == 0"
                style="cursor: pointer;"
                @click.prevent.stop="
                  askConfirm('Delete this consultant?') && consultant_delete(item.id, item.deleted)
                "
              >
                <fa-icon name="trash-alt" />
              </span>
              <span
                v-if="item.deleted == 1"
                class="icon-checkmark text-danger me-2"
                style="cursor: pointer;"
                @click.prevent.stop="consultant_delete(item.id, item.deleted)"
              ></span>
              <span
                v-if="item.deleted == 1"
                class="icon-cross text-danger"
                style="cursor: pointer;"
                @click.prevent.stop="consultant_delete(item.id, 2)"
              ></span>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :current-page="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        aria-label="Consultants pagination"
        @page-changed="currentPage = $event"
      />
  </div>
  <div class="col-12" v-if="consultant_id != 0 && sendingbulkemail == 0">
    <Consultant :key="consultant_id" />
  </div>
  <div class="col-12" v-if="sendingbulkemail == 1">
    <BulkMailing :idsArray="idsArray" :emailsArray="emailsArray" @stopsendingemail="handleStopSendingEmail" />
  </div>
</template>
<script>
/* eslint-disable no-console */
import { defineComponent, ref, computed, watch, onMounted, nextTick, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import _ from "lodash";
import LabelSelect from "./LabelSelect";
import Consultant from "./Consultant";
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
import Pagination from './Pagination.vue';
import { config } from "../../config";
import BulkMailing from "./BulkMailing.vue";

const fields = [
  { key: "id", label: "ID", sortable: true },
  // Temporarily commenting out other columns for isolation
  // { key: "consultant_name", label: "Name", sortable: true, tdClass: "col-2 gdq-w-15" },
  // { key: "email", label: "E-mail", sortable: true },
  // { key: "consultantstatus_name", label: "Status", sortable: false },
  // { key: "certificate_number", label: "GDQ#", sortable: true, tdClass: "col-1 gdq-w-5" },
  // { key: "certification_date", label: "Cert.date", sortable: true, tdClass: "col-1 gdq-w-10" },
  // { key: "partner_name", label: "Partner", sortable: false },
  // { key: "groupcount", label: "Groups", sortable: false },
  // { key: "labels", label: "Labels", sortable: false, tdClass: "col-5" },
  // { key: "actions", label: "", sortable: false, tdClass: "col-1 gdq-w-10" },
];

export default defineComponent({
  name: "Consultants",
  components: {
    LabelSelect,
    Consultant,
    Navbar,
    Breadcrumb,
    Pagination,
    BulkMailing
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { proxy } = getCurrentInstance();

    const deleteerror = ref(0);
    const consultants = ref([]);
    const allconsultants = ref([]);
    const rows = ref(0);
    const search = ref("");
    const searchId = ref(null);
    const searching = ref(false);
    const searchcalc = ref(false);
    const bulkaddinglabel = ref(0);
    const bulkaddinglabeltext = ref("");
    const exportexcelfilename = ref("");
    // Unused refs removed
    const currentPage = ref(1);
    const perPage = ref(10);
    const loading = ref(null);
    const orderby = ref("id");
    const orderdesc = ref(false);
    const selected = ref(false);
    const addinglabel = ref(0);
    const addinglabeltext = ref("");
    const filterlabel = ref(0);
    const alllabels = ref([]);
    const filterusergroup = ref(0);
    const allusergroups = ref([]);
    const consultantstate = ref(0);
    const consultantstatus_id = ref(0);
    const consultantgroup_id = ref(0);
    const consultantstatuses = ref([]);
    const consultantgroups = ref([]);
    const bulkaction = ref(0);
    const selectcount = ref(0);
    const emailtemplate = ref(0);
    const emailtemplates = ref([]);
    const newsletter = ref(null);
    const sendingbulkemail = ref(0);
    const idsArray = ref([]);
    const emailsArray = ref([]);
    const selectedId = ref(0);

    const anon = computed(() => store.state.anon);
    const consultant_id = computed({
      get() {
        return store.state.currentconsultant_id;
      },
      set(val) {
        store.dispatch("consultant_setcurrent", { consultant_id: val });
      }
    });
    const consultantlabelchanged = computed(() => store.state.consultantlabelchanged);

    const handleStopSendingEmail = () => {
      sendingbulkemail.value = false;
    };

    const emailtemplates_get = () => {
      store.dispatch("records_readall", { table_name: 'g_bulkemailtemplates'}).then((resp) => {
        emailtemplates.value = resp.data.result;
      });
    };

    const switchto = (id) => {
      store
        .dispatch("switchto", { i_name: "", i_password: "", user_id: id })
        .then((resp) => {
          window.open(config.web_url + "/?t=" + resp, "GDQSwitchTo");
        });
    };

    const dobulkaction = () => {
      if (bulkaction.value == 3) {
        router.push("/importconsultants");
      }
      if (bulkaction.value == 5 || bulkaction.value == 6) {
        bulkemailingstart();
      }
    };

    const consultant_delete = (id, deleted) => {
      const newflag = deleted != 2 ? 1 - deleted : deleted;
      const data = { id, deleted: newflag };
      store.dispatch("consultant_flagdelete", data).then((resp) => {
        if (resp.data.id == 0) {
          deleteerror.value = 1;
        } else {
          deleteerror.value = 0;
          consultants_get();
        }
        return false;
      });
    };

    const bulkaddlabel_save = () => {
      const ids = consultants.value.filter(c => c.selected).map(c => c.id);
      const data = {
        ids,
        label: bulkaddinglabeltext.value,
      };
      store.dispatch("consultantlabels_bulkadd", data).then(() => {
        bulkaction.value = 0;
        consultants_get();
      });
    };

    const bulkaddlabel_cancel = () => {
      bulkaction.value = 0;
      bulkaddinglabeltext.value = "";
    };

    const exportexcel_save = async () => {
      const download = (ids) => {
        store.dispatch("consultants_exportexcel", { ids }).then((resp) => {
          const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          const filename = exportexcelfilename.value;
          fileLink.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          bulkaction.value = 0;
        });
      };

      if (bulkaction.value == 4) {
        await consultants_getallfiltered().then(() => {
          const ids = allconsultants.value.map(c => c.id);
          download(ids);
        });
      } else {
        const ids = consultants.value.filter(c => c.selected).map(c => c.id);
        download(ids);
      }
    };

    const bulkemailingstart = async () => {
      const ids = [];
      const emails = [];
      if (bulkaction.value == 6) {
        await consultants_getallfiltered().then(() => {
          allconsultants.value.forEach((c) => {
            ids.push(c.id);
            emails.push(c.email);
          });
        });
      } else {
        consultants.value.forEach((c) => {
          if (c.selected) {
            ids.push(c.id);
            emails.push(c.email);
          }
        });
      }
      idsArray.value = ids;
      emailsArray.value = emails;
      sendingbulkemail.value = true;      
    };

    const exportexcel_cancel = () => {
      bulkaction.value = 0;
      exportexcelfilename.value = "";
    };

    const addconsultant = () => {
      store.dispatch("consultant_setcurrent", { consultant_id: -1 });
    };

    const editconsultant = (item) => {
      consultant_id.value = item.id;
      store.dispatch("consultant_setcurrent", { consultant_id: item.id });
    };

    const askConfirm = (message) => {
      return typeof window !== 'undefined' ? window.confirm(message) : false;
    };

    const saveaddlabel = () => {
      if (addinglabeltext.value != "") {
        const savelabel = {
          consultant_id: addinglabel.value,
          label: addinglabeltext.value,
        };
        store
          .dispatch("consultantlabel_add", { label: savelabel })
          .then(() => {
            labels_get();
            conlabels_get(addinglabel.value);
            addinglabel.value = 0;
            addinglabeltext.value = "";
          });
      }
    };

    const addlabel = (id) => {
      addinglabel.value = id;
      addinglabeltext.value = "";
      nextTick(() => {
        const refEl = proxy?.$refs?.[`l${id}`];
        if (refEl && typeof refEl.focus === 'function') {
          refEl.focus();
        }
      });
    };

    const removelabel = (consultant_id_param, consultantlabel_id) => {
      store
        .dispatch("consultantlabel_delete", { id: consultantlabel_id })
        .then(() => {
          labels_get();
          conlabels_get(consultant_id_param);
        });
    };

    const consultant_get = (consultant_id_param) => {
      let first_name = "";
      let family_name = "";
      let email = "";
      return store
        .dispatch("consultant_fetch", { consultant_id: consultant_id_param })
        .then((resp) => {
          first_name = resp.data.first_name;
          family_name = resp.data.family_name;
          email = resp.data.email;
          consultants.value = consultants.value.map((c) => {
            if (c.id === consultant_id_param) {
              return {
                ...c,
                consultant_name: `${family_name}, ${first_name}`,
                email,
              };
            }
            return c;
          });
          return store.dispatch("consultant_setcurrent", { consultant_id: consultant_id_param });
        });
    };

    const conlabels_get = (consultant_id_param) => {
      store
        .dispatch("consultantlabels_fetch", { consultant_id: consultant_id_param })
        .then((resp) => {
          consultants.value = consultants.value.map((c) => c.id === consultant_id_param ? { ...c, labels: resp.data } : c);
        });
    };

    const selectall = (selectedParam) => {
      const setselectto = !selectedParam;
      consultants.value = consultants.value.map((c) => ({ ...c, selected: setselectto }));
      countselected();
    };

    const countselected = () => {
      nextTick(() => {
        selectcount.value = consultants.value.filter(c => c.selected).length;
      });
    };

    const consultants_filterget = () => {
      currentPage.value = 1;
      consultants_get();
    };

    const consultants_filter = _.debounce(() => {
      searchcalc.value = true;
      setTimeout(() => {
        consultants_filterget();
        searchcalc.value = false;
        searching.value = false;
      }, 500);
    }, 300);

    // consultants_sort removed in favor of handleSort

    const handleSort = (key) => {
      if (orderby.value === key) {
        orderdesc.value = !orderdesc.value;
      } else {
        orderby.value = key;
        orderdesc.value = false;
      }
      consultants_filterget();
    };

    const consultants_get = () => {
      loading.value = true;
      const filter = {};
      if (search.value != "") {
        filter.family_name = {
            operator: "LIKE",
            value: "%" + search.value + "%",
        };
        filter.first_name = {
            operator: "LIKE",
            value: "%" + search.value + "%",
        };
        filter.email =  {
          operator: "LIKE",
          value: "%" + search.value + "%",
        };
      }
      if (searchId.value && searchId.value !== "" && parseInt(searchId.value) && parseInt(searchId.value) != 0) {
        filter.id = {
          operator: "=",
          value: searchId.value,
        };
        filter.survey_id = {
          operator: "=",
          value: searchId.value,          
        };
      }
      const params = {
          start: currentPage.value,
          limit: perPage.value,
          orderby: orderby.value,
          order: orderdesc.value == false ? "ASC" : "DESC",
          filter: filter,
          label_id: filterlabel.value ? filterlabel.value : 0,
          usergroup_id: filterusergroup.value,
          consultantstatus_id: consultantstatus_id.value,
          consultantgroup_id: consultantgroup_id.value,
          deleted: consultantstate.value,
          ...(newsletter.value !== null && { newsletter: newsletter.value ? 1 : 0 }),
      };
      store
        .dispatch("consultants_fetch", params)
        .then((resp) => {
          const result = Array.isArray(resp.data?.result) ? resp.data.result : [];
          const clean = JSON.parse(JSON.stringify(result)).map((r) => ({
            id: r.id,
            selected: false,
            consultantstatus_name: r.consultantstatus_name,
            certificate_number: r.certificate_number,
            certification_date: r.certification_date,
            consultant_name: r.consultant_name,
            partner_name: r.partner_name,
            email: r.email,
            labels: Array.isArray(r.labels) ? r.labels : [],
            deleted: r.deleted,
            groupcount: r.groupcount,
          }));
          consultants.value = clean;
          rows.value = Number(resp.data.total || clean.length);
          loading.value = false;
        });
    };

    const consultants_getallfiltered = () => {
      loading.value = true;
      let filter = "";
      if (search.value != "") {
        filter = {
          family_name: {
            operator: "LIKE",
            value: "%" + search.value + "%",
          },
          first_name: {
            operator: "LIKE",
            value: "%" + search.value + "%",
          },
          email: {
            operator: "LIKE",
            value: "%" + search.value + "%",
          },
        };
      }
      return store
        .dispatch("consultants_fetch", {
          start: 1,
          limit: 100000,
          orderby: orderby.value,
          order: orderdesc.value == false ? "ASC" : "DESC",
          filter: filter,
          label_id: filterlabel.value ? filterlabel.value : 0,
          usergroup_id: filterusergroup.value,
          consultantstatus_id: consultantstatus_id.value,
          deleted: consultantstate.value,
          ...(newsletter.value !== null && { newsletter: newsletter.value ? 1 : 0 }),
        })
        .then((resp) => {
          const result = Array.isArray(resp.data?.result) ? resp.data.result : [];
          const clean = JSON.parse(JSON.stringify(result)).map((r) => ({
            id: r.id,
            selected: false,
            consultantstatus_name: r.consultantstatus_name,
            consultant_name: r.consultant_name,
            partner_name: r.partner_name,
            email: r.email,
            labels: Array.isArray(r.labels) ? r.labels : [],
            deleted: r.deleted,
            groupcount: r.groupcount,
          }));
          allconsultants.value = clean;
          rows.value = Number(resp.data.total || clean.length);
          loading.value = false;
        });
    };

    const labels_get = () => {
      store.dispatch("labels_fetch").then((resp) => {
        const dblabels = resp.data.result;
        const labels = dblabels.map((l) => ({
          value: l.id,
          text: l.label,
          color: l.color,
        }));
        labels.unshift({ value: 0, text: "Labels", color: "ffffff" });
        alllabels.value = labels;
      });
    };

    const usergroups_get = () => {
      const usergroups = [{ value: 0, text: "Roles" }];
      for (let i = 0; i < store.state.usergroups.length; i++) {
        usergroups.push({
          value: store.state.usergroups[i].id,
          text: store.state.usergroups[i].name,
        });
      }
      allusergroups.value = usergroups;
    };

    const consultantstatuses_get = () => {
      store
        .dispatch("consultantstatuses_fetch", {
          filter: {
            consultantstatus_name: {
              operator: "<>",
              value: "",
            },
          },
          start: 1,
          limit: 999999,
          orderby: "id",
          order: "ASC",
        })
        .then((resp) => {
          const statuses = [{ value: 0, text: "Status" }];
          resp.data.result.forEach((r) => statuses.push({ value: r.id, text: r.consultantstatus_name }));
          consultantstatuses.value = statuses;
        });
    };

    const consultantgroups_get = () => {
      store.dispatch('records_readlist',{ table_name: 'g_consultantgroups' })
      .then((resp) => {
        const groups = resp.data.result.map( r => ({ value: r.id, text: r.consultantgroup_name }));
        groups.unshift({ value: 0, text: 'Groups'});
        consultantgroups.value = groups;
      });
    };

    const selectConsultant = (item) => {
      console.log('[Consultants] row click', item.id);
      selectedId.value = item.id;
      consultant_id.value = item.id;
      store.dispatch("consultant_setcurrent", { consultant_id: item.id });
    };

    watch(search, () => {
      searching.value = true;
      consultants_filter();
    });

    watch(currentPage, () => {
      consultants_get();
    });

    watch(() => store.state.consultantchanged, (val) => {
      if (val != 0) {
        consultant_get(val).then(() => {
          store.dispatch("consultantchanged_set", { consultant_id: 0 });
        });
      }
    });

    watch(consultantlabelchanged, (val) => {
      if (val != 0) {
        conlabels_get(val);
        store.dispatch("consultantlabelchanged_set", {
          consultant_id: 0,
        });
      }
    });

    watch([filterlabel, filterusergroup, consultantstatus_id, consultantgroup_id, newsletter, consultantstate], () => {
      consultants_filterget();
    });

    onMounted(() => {
      consultantstatuses_get();
      consultantgroups_get();
      labels_get();
      usergroups_get();
      filterlabel.value = 0;
      consultants_get();
      emailtemplates_get();
    });

    return {
      fields,
      deleteerror,
      consultants,
      rows,
      search,
      searchId,
      searching,
      searchcalc,
      bulkaddinglabel,
      bulkaddinglabeltext,
      exportexcelfilename,
      allconsultants,
      selectedId,
      currentPage,
      perPage,
      loading,
      orderby,
      orderdesc,
      selected,
      addinglabel,
      addinglabeltext,
      filterlabel,
      alllabels,
      filterusergroup,
      allusergroups,
      consultantstate,
      consultantstatus_id,
      consultantgroup_id,
      consultantstatuses,
      consultantgroups,
      bulkaction,
      selectcount,
      emailtemplate,
      emailtemplates,
      newsletter,
      sendingbulkemail,
      idsArray,
      emailsArray,
      anon,
      consultant_id,
      consultantlabelchanged,
      selectConsultant,
      handleStopSendingEmail,
      emailtemplates_get,
      switchto,
      dobulkaction,
      consultant_delete,
      bulkaddlabel_save,
      bulkaddlabel_cancel,
      exportexcel_save,
      bulkemailingstart,
      exportexcel_cancel,
      addconsultant,
      editconsultant,
      saveaddlabel,
      addlabel,
      removelabel,
      consultant_get,
      conlabels_get,
      askConfirm,
      selectall,
      countselected,
      handleSort,
      consultants_filter,
      consultants_filterget,
      consultants_get,
      consultants_getallfiltered,
      labels_get,
      usergroups_get,
      consultantstatuses_get,
      consultantgroups_get,
    };
  },
});
</script>
<style>
.gdq-faded {
  opacity: 0.5;
}
.headselect {
  color: red;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 30px;
  position: absolute;
  top: 20px;
}
.consultantsTable {
  font-size: 0.9rem !important;
}
</style>
